import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment';

import { formatMoney, formatNumber } from 'accounting-js';

// Get Current Date
const today = new Date();
const currentYear = today.getFullYear();
const currentMonth = today.getMonth() + 1;

export default class ReportsDepreciationRow extends PureComponent {
  static propTypes = {
    asset: PropTypes.object.isRequired,
    depreciation: PropTypes.oneOf(['fiscal', 'financial']).isRequired,
  };

  hasError = () => {
    switch (this.props.depreciation) {
      case 'fiscal':
        return !this.props.asset._fiscalDepreciationResult;
      case 'financial':
        return !this.props.asset._financialDepreciationResult;
      default:
        return true;
    }
  };

  hasWarning = () => {
    const depreciation = this.depreciation();
    return depreciation.factors && depreciation.factors.warning;
  };

  depreciation = () => {
    switch (this.props.depreciation) {
      case 'fiscal':
        return this.props.asset._fiscalDepreciationResult || {};
      case 'financial':
        return this.props.asset._financialDepreciationResult || {};
      default:
        return true;
    }
  };

  render = () => {
    const depreciation = this.depreciation();

    // Subtract this.props.asset.startDate - today
    const diff = moment(today).diff(moment(this.props.asset.startDate), 'months');

    return (
      <tr
        className={classnames({
          'table-warning': this.hasWarning(),
          'table-danger': this.hasError(),
        })}
      >
        <td className="align-middle" style={{ whiteSpace: 'nowrap' }}>
          {this.props.asset.number}
        </td>
        <td className="align-middle" style={{ whiteSpace: 'nowrap' }}>
          {this.props.asset.name}
        </td>
        <td className="align-middle" style={{ whiteSpace: 'nowrap' }}>
          {this.props.asset.brand}
        </td>
        <td className="align-middle" style={{ whiteSpace: 'nowrap' }}>
          {this.props.asset.model}
        </td>
        <td className="align-middle" style={{ whiteSpace: 'nowrap' }}>
          {this.props.asset.serie}
        </td>
        <td className="align-middle" style={{ whiteSpace: 'nowrap' }}>
          {this.props.asset._costCenter
            ? `${this.props.asset._costCenter.key} - ${this.props.asset._costCenter.name}`
            : ''}
        </td>
        <td className="align-middle" style={{ whiteSpace: 'nowrap' }}>
          {this.props.asset._account ? `${this.props.asset._account.key}` : ''}
        </td>
        <td className="align-middle" style={{ whiteSpace: 'nowrap' }}>
          {this.props.asset._account ? `${this.props.asset._account.name}` : ''}
        </td>
        <td className="text-center align-middle">
          {this.props.asset.buyDate ? moment(this.props.asset.buyDate).format('DD/MM/YYYY') : ''}
        </td>
        <td className="text-center align-middle">
          {this.props.asset.startDate
            ? moment(this.props.asset.startDate).format('DD/MM/YYYY')
            : ''}
        </td>
        <td className="text-center align-middle">{depreciation.name}</td>

        <td className="text-right align-middle" style={{ whiteSpace: 'nowrap' }}>
          {formatMoney(this.props.asset.price || 0)}
        </td>
        <td className="text-right align-middle" style={{ whiteSpace: 'nowrap' }}>
          {formatMoney(this.props.asset.dollarAssetPrice || 0)}
        </td>
        <td className="text-center align-middle" style={{ whiteSpace: 'nowrap' }}>
          {formatNumber(parseFloat(depreciation.totalLifeYears) || 0, {
            precision: 0,
          })}
        </td>
        <td className="text-center align-middle" style={{ whiteSpace: 'nowrap' }}>
          {formatNumber(
            depreciation.factors && depreciation.factors.acumulado < depreciation.totalLifeMonths
              ? depreciation.factors.countMonthDep
              : 0,
            { precision: 0 }
          )}
        </td>
        <td className="text-center align-middle" style={{ whiteSpace: 'nowrap' }}>
          {formatNumber(
            depreciation.factors
              ? formatNumber(
                  depreciation.factors.acumulado < depreciation.totalLifeMonths
                    ? depreciation.factors.acumulado - depreciation.factors.countMonthDep
                    : depreciation.factors.acumulado > depreciation.totalLifeMonths
                    ? depreciation.factors.acumulado - 1
                    : depreciation.factors.acumulado
                )
              : 0,
            { precision: 0 }
          )}
        </td>
        <td className="text-center align-middle" style={{ whiteSpace: 'nowrap' }}>
          {formatNumber(
            depreciation.factors
              ? depreciation.factors.acumulado < depreciation.totalLifeMonths
                ? depreciation.factors.acumulado
                : diff - 1 > depreciation.factors.acumulado
                ? 0
                : 0
              : 0,
            { precision: 0 }
          )}
        </td>
        <td className="text-center align-middle" style={{ whiteSpace: 'nowrap' }}>
          {formatNumber(depreciation.totalLifeMonths || 0, { precision: 0 })}
        </td>
        <td className="text-center align-middle" style={{ whiteSpace: 'nowrap' }}>
          {formatNumber(parseFloat(depreciation.lifeYears) || 0, {
            precision: 4,
          })}
        </td>
        <td className="text-right align-middle" style={{ whiteSpace: 'nowrap' }}>
          {formatMoney(depreciation.originalAmount || 0)}
        </td>
        <td className="text-right align-middle" style={{ whiteSpace: 'nowrap' }}>
          {formatMoney(
            depreciation.factors && depreciation.factors.acumulado < depreciation.totalLifeMonths
              ? depreciation.lastPeriodDepreciation
              : depreciation.lastPeriodDepreciation + depreciation.currentNormalDepreciation || 0,
            { precision: 0 }
          )}
        </td>
        <td className="text-right align-middle" style={{ whiteSpace: 'nowrap' }}>
          {formatMoney(
            depreciation.factors
              ? depreciation.factors.acumulado < depreciation.totalLifeMonths
                ? depreciation.currentNormalDepreciation
                : diff - 1 > depreciation.factors.acumulado
                ? 0
                : depreciation.currentNormalDepreciation
              : 0,
            { precision: 0 }
          )}
        </td>
        <td className="text-right align-middle" style={{ whiteSpace: 'nowrap' }}>
          {formatMoney(
            depreciation.factors
              ? depreciation.factors.acumulado < depreciation.totalLifeMonths
                ? depreciation.depMonthly
                : diff - 1 > depreciation.factors.acumulado
                ? 0
                : depreciation.depMonthly
              : 0,
            { precision: 0 }
          )}
        </td>
        <td className="text-right align-middle" style={{ whiteSpace: 'nowrap' }}>
          {formatMoney(
            depreciation.factors
              ? depreciation.factors.acumulado < depreciation.totalLifeMonths
                ? depreciation.depMonthlyUsd
                : diff - 1 > depreciation.factors.acumulado
                ? 0
                : depreciation.depMonthlyUsd
              : 0,
            { precision: 0 }
          )}
        </td>
        <td className="text-right align-middle" style={{ whiteSpace: 'nowrap' }}>
          {formatNumber(depreciation.factors ? depreciation.factors.inpcBegin : 0, {
            precision: 4,
          })}
        </td>
        <td className="text-right align-middle" style={{ whiteSpace: 'nowrap' }}>
          {formatNumber(depreciation.factors ? depreciation.factors.inpcEnd : 0, { precision: 4 })}
        </td>
        <td className="text-right align-middle" style={{ whiteSpace: 'nowrap' }}>
          {formatNumber(depreciation.factors ? depreciation.factors.factor : 0, { precision: 4 })}
        </td>
        <td className="text-right align-middle" style={{ whiteSpace: 'nowrap' }}>
          {formatMoney(depreciation.currentDepreciation || 0)}
        </td>
        <td className="text-right align-middle" style={{ whiteSpace: 'nowrap' }}>
          {formatMoney(depreciation.totalDepreciation || 0)}
        </td>
        <td className="text-right align-middle" style={{ whiteSpace: 'nowrap' }}>
          {formatMoney(depreciation.depreciable || 0)}
        </td>
      </tr>
    );
  };
}



// WEBPACK FOOTER //
// src/components/reports/ReportsDepreciationRow.js